import styled from 'styled-components'

interface SizeProps {
  fontSize: string
}

export const Container = styled.div<{isDisabled?: boolean}>`
div:first-child{
    display: flex;
}
position: relative;
margin-left: 1.5rem;

${({ isDisabled }) => isDisabled && `
        opacity:.5;
        pointer-events:none;
`}
`

export const CircleDiv = styled.div`
display: flex;
flex-direction: column;
align-items: center;
hr{
    height: 100%;
    width: .25rem;
    background: var(--terc6);
    border: none;
}
`

export const CardDiv = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    border-radius:.75rem;
    background: #${props => props.theme};
    box-shadow: var(--SombraBackground);
    color: white;
    cursor: pointer;
    min-height: 64px;
    padding-left: 1.5rem;
    padding-right: 1.5rem;

    &:hover{
        box-shadow: var(--SombraBtns);
        filter: brightness(.9);
    }
`

export const BackgroundCard = styled.div<{ isOpen?: boolean }>`
    display: flex;
    flex-direction: column;
    background:#${props => props.theme};
    border-radius: .75rem;
    margin-bottom: 2rem;
    overflow-y: hidden;
    border-bottom-left-radius: .75rem;
    border-bottom-right-radius: .75rem;
    transition: max-height .7s;
    max-height:64px;

    ${({ isOpen }) => isOpen && `
        border-bottom-left-radius: .75rem;
        border-bottom-right-radius: .75rem;
        transition: max-height 1.2s;
        max-height: 100rem;
    `}
`

export const BodyCard = styled.div<{ isOpen?: boolean }>`
    display: flex;
    flex-direction: column;
    padding: .75rem 1.25rem 1.25rem 1.25rem;
    pointer-events: none;

    ${({ isOpen }) => isOpen && `
        pointer-events: unset;
    `}
`

export const CircleCard = styled.div<SizeProps>`
background: var(--c1);
color: var(--a3);
border: solid var(--terc6);
border-width: 0.3rem;
box-sizing: border-box;
min-height: 4rem;
width: 4rem;
border-radius: 2rem;
display: flex;
justify-content:center ;
text-align: center;
align-items: center;
font-family: 'Poppins';
font-size: ${props => props.fontSize}rem;
font-weight: 800;
`

export const FlexElipse = styled.div`
display: flex;
height: 4.313rem;
align-items: center;
margin-left: .325rem;

div{
    margin-right:.25rem;
}

div:nth-child(1){
    height: 0.5rem;
    width: 0.5rem;
    background: #${props => props.color}40;
    border-radius: 50%;
}

div:nth-child(2){
    height: 0.625rem;
    width: 0.625rem;
    background: #${props => props.color}80;
    border-radius: 50%;
}

div:nth-child(3){
    height: .75rem;
    width: .75rem;
    background:#${props => props.color};
    border-radius: 50%;
    margin-right: .5rem;
}
`

export const EditMenu = styled.div<{isOpen?: boolean}>`
display: flex;
position: relative;
left: -5rem;
transition: all 0.9s ease;
opacity: 0%;
position: relative;
pointer-events:none;
margin-left:.75rem;
font-size: .875rem;

${({ isOpen }) => isOpen && `
       pointer-events:unset ;
       left: 0rem;
       opacity: 100%;
    `}

svg{
    margin-left: 0rem!important;
}

a{
    justify-content: center;
    align-items: center;
    height: fit-content;
    margin-right: .75rem;
    height: 2.125rem;
    width: 2.125rem;
    display: flex;
    border-radius: 50%;
    cursor: pointer;
    position: relative;
    top: 1rem;
}

a:nth-child(1){
    border: 2px solid var(--a1);
    color: var(--a1);

    &:hover{
        background: var(--a1);
        color: white;
    }
}

a:nth-child(2){
    border: 2px solid var(--terc1);
    color: var(--terc1);

    &:hover{
        background: var(--terc1);
        color: white;
    }
}

a:nth-child(3){
    border: 2px solid var(--Roxo);
    color: var(--Roxo);

    &:hover{
        background: var(--Roxo);
        color: white;
    }
}

a:nth-child(4){
    border: 2px solid var(--Rosa);
    color: var(--Rosa);

    &:hover{
        background: var(--Rosa);
        color: white;
    }
}
`
